function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useCallback } from 'react';
import { Icon } from '@keen.io/icons';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { Container, Wrapper } from './PropertyPath.styles';
var OVERFLOW_CONTENT = '...';

var PropertyPath = function PropertyPath(_ref) {
  var path = _ref.path;
  var pathLength = path.length;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOverflow = _useState2[0],
      setOverflow = _useState2[1];

  var propertyRef = useCallback(function (node) {
    if (node !== null) {
      var overflow = node.scrollWidth > node.offsetWidth;
      setOverflow(overflow);
    }
  }, []);
  return React.createElement(Container, {
    ref: propertyRef
  }, path.map(function (slice, idx, arr) {
    if (idx + 1 < pathLength) {
      return [React.createElement(BodyText, {
        variant: "body2",
        color: colors.blue[500],
        key: "".concat(slice, "-").concat(idx)
      }, isOverflow && idx !== arr.length - 1 ? OVERFLOW_CONTENT : slice), React.createElement(Wrapper, {
        key: "".concat(slice, "-").concat(idx, "-wrapper")
      }, React.createElement(Icon, {
        type: "caret-right",
        width: 10,
        height: 10,
        fill: colors.blue[100]
      }))];
    }

    return React.createElement(BodyText, {
      variant: "body2",
      color: colors.blue[500],
      key: "".concat(slice, "-").concat(idx)
    }, slice);
  }));
};

export default PropertyPath;